/** 打开外链
 * web端：直接打开空白页
 * 插件端：使用客户默认的浏览器打开页面
 * **/

import { mapGetters } from 'vuex'
import { NavigateToBrowser } from '@/core/gcsUtils'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
    }),
  },
  methods: {
    async openUrl(url, needLogin = false, type = '_blank',) {
      if (this.platform === 'web') {
        window.open(url, type)
      } else {
        if (needLogin) {
          const webUrl = await this.$api.user.ssoUrl({ dest: url })
          this.clientNavigateToBrowser(webUrl)
        } else {
          this.clientNavigateToBrowser(url)
        }
      }
    },
    clientNavigateToBrowser(url) {
      if (this.$desktopClient) {
        this.$desktopClient.NavigateToBrowser(url)
      } else if (this.$revitClient) {
        this.$revitClient.NavigateToBrowser(url)
      } else {
        NavigateToBrowser(url).catch()
      }
    }
  }
}
